import { useTranslation } from "react-i18next";
import { CAlert, CCol, CRow, CSpinner } from "@coreui/react-pro";
import { usableOffers, useUsableOffers } from "../../api/hooks/useOffers";
import { OfferCard } from "../../components/common/OfferCard";

/**
 * Every offer the customer can use, not just the two the dashboard shows.
 *
 * Unlike the dashboard slot this does render its empty and failed states: someone who clicked "Your
 * offers" asked the question, and an empty page answers it where a missing one looks broken.
 */
export function Offers() {
  const { t } = useTranslation("offers");
  const query = useUsableOffers();
  const offers = usableOffers(query.data);

  return (
    <div>
      <h1 className="mb-1">{t("page.title")}</h1>
      <p className="text-body-secondary mb-4">{t("page.description")}</p>

      {query.isLoading && (
        <div className="text-center py-5">
          <CSpinner />
        </div>
      )}

      {query.isError && <CAlert color="danger">{t("page.loadError")}</CAlert>}

      {!query.isLoading && !query.isError && offers.length === 0 && (
        <CAlert color="info">{t("page.none")}</CAlert>
      )}

      <CRow xs={{ gutter: 4 }}>
        {offers.map((offer) => (
          <CCol key={offer.id} md={6} xl={4}>
            <OfferCard offer={offer} className="h-100" />
          </CCol>
        ))}
      </CRow>
    </div>
  );
}

export default Offers;
